module.exports = __webpack_public_path__ + "img/bg.ab12d411.png";